module.exports = __webpack_public_path__ + "static/media/6-7.d8879061.webp";